; (function (jQuery) {

	"use strict";

	function Main() {
		var global = {
			navExpanded: false
		};

		var fn = {
			init: function ()
			{
				jQuery('.no-js').removeClass('no-js');

				jQuery('main').fitVids({
					customSelector: 'iframe[data-src*="youtube.com"], iframe[data-src*="youtube-nocookie.com"]',
				});

				jQuery('header').on('click', '.nav-bar__menu-btn', fn.handleMobileMenuExpansion);		

				jQuery('.faqs__question').on('click', fn.handleFAQExpansion);
				jQuery('.faqs__question').on('keyup', function(event) {	
					if (event.key == "Enter") {
						fn.handleFAQExpansion(event);
					}
				});

				jQuery('.match-height').matchHeight();
				jQuery('.match-height-sub-1').matchHeight();
				jQuery('.match-height-sub-2').matchHeight();
				jQuery('.match-height-sub-3').matchHeight();
				jQuery('.match-height-sub-4').matchHeight();
				jQuery('.match-height-sub-5').matchHeight();
				jQuery('.match-height').matchHeight(); // Repeated

				// Iframe responsive layouts
				// Not used. Replaced by fitvids
				//jQuery('iframe').each(fn.wrapIframes); 
				//jQuery('.calculate-aspect-ratio').each(fn.calculateAspectRatio);

				// Wrap Images for coloured background effect
				jQuery('.wysiwyg-text img.alignnone').each(fn.wrapImageHTML5);

				// Membership Directory Filters
				jQuery('.member-filter-item .form-search button').on('click', fn.filterMembers);
				jQuery('.member-filter-item .form-search input[type="search"]').keyup(function(event) {
					if (jQuery(this) && event.key == "Enter") {
						fn.filterMembers();
					}
				});
				jQuery('.member-filter-item select').on('change', fn.filterMembers);

			},


			handleMobileMenuExpansion: function()
			{
				var navBarMenu = jQuery('.nav-bar__menu-container');
				var navBarButtons = jQuery('.nav-bar__menu-btn');
				if (!global.navExpanded)
				{
					global.navExpanded = true;
					navBarMenu.addClass('nav-bar__menu-container--active');
					navBarButtons.attr('aria-expanded', 'true');
				}
				else
				{
					global.navExpanded = false;
					navBarMenu.removeClass('nav-bar__menu-container--active');
					navBarButtons.attr('aria-expanded', 'false');
				}
			},


			handleFAQExpansion: function(event)
			{
				var FAQItem = jQuery(event.target).closest('.faqs__item');
				var FAQAnswer = FAQItem.find('.faqs__answer');
				if (FAQItem.hasClass('faqs__item--open'))
				{
					FAQItem.removeClass('faqs__item--open');
					FAQAnswer.hide();
				}
				else
				{
					FAQItem.addClass('faqs__item--open');
					FAQAnswer.show();
				}
			},


			// Responsive Videos & Google Maps
			// 1. Wrap any iframes with aspect ratio calculation div (if not already wrapped in templates)
			wrapIframes: function(i, iframe)
			{
				if (!jQuery(iframe).parent('.calculate-aspect-ratio').length)
				{
					jQuery(iframe).wrap('<div class="calculate-aspect-ratio"></div>');
				}
			},
			// 2. Calculate Aspect Ratio of iFramed content
			// Uses padding-bottom % to allow responsive iFrames
			calculateAspectRatio: function(i, container)
			{
				// Responsive Iframes
				var iframe = jQuery(container).find('iframe');
				if (iframe.length) {
					var height = iframe.attr('height');
					var width = iframe.attr('width');
					if (!isNaN(height) && !isNaN(width) && (+height + +width) > 0) {
						var ratio = height / width * 100;
						jQuery(container).css('padding-bottom', ratio + '%');
					}
				}
			},


			// Wrap WYSIWYG Images 
			wrapImageHTML5: function(i, img)
			{
				jQuery(img).removeClass('alignnone').unwrap('p').wrap('<figure></figure>');
			},


			// Filter Membership Directory page
			filterMembers: function()
			{
				let args = {};

				// Check Search Filter
				if (jQuery('.member-filter-item input[type=search]').val())
				{
					args['keyword'] = jQuery('.member-filter-item input[type=search]').val();
				};

				// Check Select Filters
				jQuery('.member-filter-item select').each(function(i, filter) {
					if (!["-1", ""].includes(filter.value))
					{
						args[filter.name] = filter.value;
					}
				});

				//console.log(args);

				// Reload Page with Args
				const url = new URL(window.location.href);
				url.search = new URLSearchParams(args);
				window.location.href = url;				
				
			}

		}

		jQuery(fn.init);
	}

	new Main();
})(jQuery);